import { withRouter } from 'react-router';

import ExchangeConfirmSelection from './ExchangeConfirmSelection';

export default withRouter(ExchangeConfirmSelection);
